// extracted by mini-css-extract-plugin
export default {"uppercase":"XpngTdAeJ6Mcmjgun4GN"};